var chunkToChildrenMap = {
	"5634": [
		6665,
		1627
	],
	"6665": [
		7584,
		4568
	],
	"8741": [
		1627
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));